export const GET_TEACHERDAY_TIMETABLE = 'teacher_timetable/GET_TEACHERDAY_TIMETABLE';
export const GET_TEACHERDAY_TIMETABLE_SUCCESS =
  'teacher_timetable/GET_TEACHERDAY_TIMETABLE_SUCCESS';
